import React from 'react';
import Chart from 'react-apexcharts';
import { Box } from '@mui/material';
const PerformanceGauge = () => {
  const options = {
    chart: {
      type: 'radialBar',
      offsetY: -20,
      sparkline: {
        enabled: true,
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: false,
          delay: 0
        },
        dynamicAnimation: {
          enabled: false,
          speed: 500
        }
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#34384C',
          strokeWidth: '97%',
          margin: 5,
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: '#444',
            opacity: 1,
            blur: 2,
          },
        },
        dataLabels: {
          name: {
            show: true,
            offsetY: 20,
            fontWeight: '400',
            fontSize: '12px',
            color: '#fff',
            formatter: () => 'Performance Score',
          },
          value: {
            offsetY: -10,
            fontSize: '22px',
            color: '#fff',
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    grid: {
      padding: {
        top: -10,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        gradientToColors: ['#D36A08'],
        shadeIntensity: 0.8,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
      colors: ['#fff'],
    },
    labels: ['Average Results'],
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 220 },
          plotOptions: {
            radialBar: {
              dataLabels: {
                value: { fontSize: '18px' },
                name: { fontSize: '10px' }
              }
            }
          }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: { height: 180 },
          plotOptions: {
            radialBar: {
              dataLabels: {
                value: { fontSize: '16px' },
                name: { fontSize: '9px' }
              }
            }
          }
        }
      }
    ]
  };

  const series = [76];

  return (
    <Box
      id="chart"
      sx={{
        width: '100%',
        maxWidth: '350px',
        height: { xl: '168px', lg: '144px', md: '145px', sm: '168px', xs: '168px' },              // LOCK the height here
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Chart
        options={options}
        series={series}
        type="radialBar"
        height={300}                 // Match this with container height
        width="100%"
      />
    </Box>

  );
};

export default PerformanceGauge;
